/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import ClientsTable from './components/ClientsTable'
import ClientsTableHeader from './components/ClientsTableHeader'
import { Button } from '../../common/Button/Button'
import Loading from '../../common/Loading/Loading'
import PopUp from '../../common/PopUp/PopUp'
import DatePicker from '../../common/DatePicker/DatePicker'

/**
 *     Import
 *     - CSS
 */
import './styles/Clients.css'
import PolicyIdField from '../../common/PolicyId/PolicyId'

/**
 * Clients section class
 *
 * @export
 * @class Clients
 * @extends {React.Component<any, any>}
 */
export default class Clients extends React.Component<any, any> {

    /**
     * Creates an instance of Clients.
     * @param {*} props
     * @memberof Clients
     */
    constructor(props: any) {
        super(props)
        this.state = {
            typeSelected: 'quotes',
            bindPopUp: {
                show: false,
                quoteId: '',
                isCommercialProperty: false,
                quoteVariationId: '',
                quoteType: '',
                policyNumber: null,
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: Number,
                commission: '',
                excess: Number,
                policyName: '',
                isCollectors: false,
                isDealersStock: false,
                isMuseums: false,
                isWineSpirits: false,
                bespokePolicyId: '',
            },
            bindPopUpSendShow: false,
            quotes: [],
            policies: [],
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
                search: '',
            },
            boundBind: false,
            bindLoading: false,
            bindError: false,
        }
    }

    /**
     * Will check the URL before the component mounts and will redirect
     * to the correct site of the application
     *
     * @memberof Clients
     */
    componentWillMount() {
        let urlType = this.props.history.location.pathname.split('/')[
            this.props.history.location.pathname.split('/').length - 1
        ]

        if (urlType === 'clients' || urlType === '') {
            this.props.history.push('/clients/quotes')
        } else if (this.state.typeSelected !== urlType) {
            this.setState({ typeSelected: urlType })
        }
        this.props.fecthQuoteList()
        this.props.fecthPoliciesList()
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fecthQuoteList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType,
                '',
                nextState.filters.search
            )
            this.props.fecthPoliciesList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType,
                '',
                nextState.filters.search
            )
        }
    }

    /**
     * Will handle the footer click for more data loading
     *
     * @memberof Clients
     */
    handleFooterClick = () => {
        const filters = this.state.filters
        this.setState({
            filters: {
                ...filters,
                perPage: filters.perPage + 20,
            },
        })
    }

    /**
     * Will change the section between quotes and policies
     *
     * @memberof Clients
     * @param {string} newType the new type to change: quotes or policies
     */
    changeSelectedType = (newType: string) => {
        this.props.history.push('/clients/' + newType)
        this.setState({ typeSelected: newType })
    }

    /**
     * Will update the component's state with the new data coming
     * from the childs components
     *
     * @memberof Clients
     * @param {string} type the type of the data to update
     * @param {Object} data the actual data to update the type with
     */
    updateData = (type: string, data: object) => {
        type = type.toLowerCase()
        switch (type) {
            case 'quotes':
                this.setState({ quotes: data })
                break

            case 'policies':
                this.setState({ policies: data })

                break
            default:
                break
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Clients
     * @param {Object} params
     */
    filterTrigger = (params: any) => {
        this.setState({
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
                search: this.state.filters.search,
            },
        })
    }

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any, inceptionDate: any, bespokePolicyId: any) => {
        this.setState({ bindLoading: true })
        this.props.bindQuoteVariation(quoteId, quoteVariationId, inceptionDate, bespokePolicyId).then((response) => {
            if (response.value) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: true,
                            bindLoading: false,
                        })
                    },
                    300)
            }
        }).catch((response) => {
            if (response.error) {
                setTimeout(
                    () => {
                        this.setState({
                            boundBind: false,
                            bindLoading: false,
                        })
                    },
                    300)
            }
        })
        this.setState(
            {
                bindPopUp: {
                    show: false,
                    quoteId: '',
                    quoteVariationId: '',
                    businessName: '',
                    quoteRef: '',
                    inceptionDate: '',
                    printDate: '',
                    premium: Number,
                    commission: '',
                    excess: Number,
                    policyName: '',
                    isCollectors: false,
                    isDealersStock: false,
                    isMuseums: false,
                    isWineSpirits: false,
                    bespokePolicyId: '',
                },
                bindPopUpSendShow: false,
                quoteVariationId,
            }
        )
    }

    printDate = () => {
        return this.state.bindPopUp.printDate
    }

    handleInput = (event) => {
        let _bindpopup = this.state.bindPopUp
        _bindpopup.bespokePolicyId = event.target.value
        this.setState({ bindPopUp: _bindpopup })
    }

    handleSearchFrom = (search: string) => {
        this.setState({ filters: { ...this.state.filters, search } })
    }

    render() {
        // Sets the length of the array
        const { quoteList, policyList } = this.props.clientList

        const quotesCount = get(quoteList, 'totalNumber', 0)
        const policiesCount = get(policyList, 'totalNumber', 0)
        const quotesViewCount = get(quoteList, 'quotes', [])
        const policiesViewCount = get(policyList, 'policies', [])

        const { bindPopUp } = this.state

        return (
            <div className="clients">
                {
                    (this.props.step05.error) ?
                        < PopUp
                            title={this.props.step05.error.variation ? 'Quote Referred' : 'Something went wrong'}
                            buttonText="Close"
                            action={() => {
                                this.setState({ bindError: false })
                                this.props.step05.error = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.step05.error.error}
                        </ PopUp>
                        :
                        null
                }

                {
                    (this.state.bindLoading) ?
                        <PopUp
                            title="Quote Bound Loading"
                            action={() => { '' }}
                        >
                            ...loading
                        </PopUp> : null
                }

                {
                    (this.state.boundBind) ?
                        <PopUp
                            title="Quote Bound"
                            buttonText="Quote Bound"
                            action={() =>
                                this.props.history.push(`/clients/quotes/bound/${this.props.step05.response.policy.id}`)
                            }
                        >
                            The quote has been bound
                        </PopUp> : null
                }

                <HeaderContainer
                    className="clients__header"
                    fullwidth={true}
                    titles={['quotes', 'policies']}
                    selected={this.state.typeSelected}
                    triggerAction={this.changeSelectedType}
                    searchBarVisible={true}
                    onSearch={(value) => this.handleSearchFrom(value)}
                >
                    {(this.state.typeSelected === 'quotes') ?
                        <div className="quotesCount">
                            {`${quotesCount} active ${(quotesCount === 1) ? 'quote' : 'quotes'}`}
                        </div>
                        :
                        <div className="quotesCount">
                            {`${policiesCount} active ${(policiesCount === 1) ? 'policy' : 'policies'}`}
                        </div>}
                </HeaderContainer>

                {
                    this.state.bindPopUp.show &&
                    < PopUp
                        title="Select Inception Date"
                        buttonText="Cancel"
                        action={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: Number,
                                            commission: '',
                                            excess: Number,
                                            policyName: '',
                                            isCollectors: false,
                                            isDealersStock: false,
                                            isMuseums: false,
                                            isWineSpirits: false,
                                            bespokePolicyId: '',
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            <PolicyIdField
                                quoteType={this.state.bindPopUp.quoteType}
                                onChange={this.handleInput}
                            />
                            <div className="quotePreview__row">
                                <div className="text">
                                    Please enter the inception date:
                                </div>
                                <div className="quotePreview__row__inception_date">
                                    <DatePicker
                                        placeholder="Policy inception date"
                                        step05inceptionDate={this.printDate()}
                                        onChange={(inceptionDate) => this.setState(
                                            {
                                                bindPopUp:
                                                    { ...this.state.bindPopUp, inceptionDate, show: false },
                                                bindPopUpSendShow: true,
                                            }

                                        )}
                                        onFocus={() => null}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopUp >
                }

                {
                    (this.state.bindPopUpSendShow) ?
                        < PopUp
                            title="Do you want to bind this quote?"
                            buttonText="Bind"
                            action={
                                () => {
                                    this.handleBind(
                                        this.state.bindPopUp.quoteId,
                                        this.state.bindPopUp.quoteVariationId,
                                        this.state.bindPopUp.inceptionDate,
                                        this.state.bindPopUp.bespokePolicyId
                                    )
                                }
                            }
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={
                                () =>
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: false,
                                                quoteId: '',
                                                quoteVariationId: '',
                                                businessName: '',
                                                quoteRef: '',
                                                inceptionDate: '',
                                                printDate: '',
                                                premium: Number,
                                                commission: '',
                                                excess: Number,
                                                policyName: '',
                                                isCollectors: false,
                                                isDealersStock: false,
                                                isMuseums: false,
                                                isWineSpirits: false,
                                                bespokePolicyId: '',
                                            },
                                            bindPopUpSendShow: false,
                                        }
                                    )
                            }
                        >
                            <div className="quotePreview__box">
                                <div className="quotePreview__header">
                                    <div className="quotePreview__header__title">
                                        {this.state.bindPopUp.businessName}
                                    </div>
                                    <div className="quotePreview__header__subtitle">
                                        {(this.state.bindPopUp.policyName === 'Collectors' || bindPopUp.isCollectors) ?
                                            'Collections Insurance' : bindPopUp.isMuseums ? 'Museums Insurance' :
                                                bindPopUp.isDealersStock ? 'Dealers Stock Insurance' :
                                                    bindPopUp.isWineSpirits ? 'Wine & Spirits Insurance' :
                                                        'Commercial Art Insurance'}
                                    </div>
                                    <div className="quotePreview__header__policyInfo">
                                        Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Inception date</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Date quoted</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.printDate}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Premium</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{(this.state.bindPopUp.premium).toLocaleString('en-GB', {
                                                style: 'currency',
                                                currency: 'GBP',
                                            })}</span> inc.IPT
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Your commission</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Excess</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>
                                                {(typeof (this.state.bindPopUp.excess) === 'number') ?
                                                    (this.state.bindPopUp.excess).toLocaleString('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                    })
                                                    : `£${this.state.bindPopUp.excess}`
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PopUp > :
                        null
                }

                {
                    (this.state.typeSelected === 'quotes') ?
                        <div>
                            <ClientsTableHeader
                                state={this.state}
                                dataType={this.state.typeSelected}
                                filterTrigger={this.filterTrigger}
                            />
                            <Container className="clients clients__table table__content" fullwidth={false}>
                                <ClientsTable
                                    clientList={this.props.clientList}
                                    dataType={this.state.typeSelected}
                                    updateData={this.updateData}
                                    history={this.props.history}
                                    confirmEditQuote={this.props.confirmEditQuote}
                                    bindClick={
                                        (quote, variation) => {
                                            this.setState(
                                                {
                                                    bindPopUp: {
                                                        show: true,
                                                        quoteId: quote.id,
                                                        isCommercialProperty: quote.isCommercialProperty,
                                                        quoteVariationId: variation.id,
                                                        quoteType: variation.quoteType,
                                                        policyNumber: variation.hiscoxPolicyNo,
                                                        businessName: quote.clientName,
                                                        quoteRef: variation.quoteRef,
                                                        inceptionDate: '',
                                                        printDate: quote.quotedDate,
                                                        premium: variation.premium,
                                                        commission: variation.commission,
                                                        excess: variation.excess,
                                                        policyName: quote.policyName,
                                                        isCollectors: quote.isCollectors,
                                                        isDealersStock: quote.isDealersStock,
                                                        isMuseums: quote.isMuseums,
                                                        isWineSpirits: quote.isWineSpirits,
                                                        bespokePolicyId: '',
                                                    },
                                                }
                                            )
                                        }
                                    }
                                />
                            </Container>
                            <div className="clients__footer">
                                <div className="clients__ clients__footer--brick quote_load_more" >
                                    {
                                        (this.props.clientList.loading) ?
                                            <Loading />
                                            :
                                            <Button
                                                type="submit"
                                                onClick={this.handleFooterClick}
                                                disabled={quotesViewCount.length === quotesCount}
                                            >
                                                Load more
                                            </Button>
                                    }
                                </div>
                            </div>

                        </div>
                        :
                        <div>
                            <ClientsTableHeader
                                state={this.state}
                                dataType={this.state.typeSelected}
                                filterTrigger={this.filterTrigger}
                            />
                            <Container
                                className="clients clients__table table__content"
                                fullwidth={false}
                            >
                                <ClientsTable
                                    clientList={this.props.clientList}
                                    dataType={this.state.typeSelected}
                                    updateData={this.updateData}
                                    history={this.props.history}
                                />
                            </Container>
                            <div className="clients__footer">
                                <div className="clients__ clients__footer--brick" >
                                    {
                                        (this.props.clientList.loading) ?
                                            <Loading />
                                            :
                                            <Button
                                                type="submit"
                                                onClick={this.handleFooterClick}
                                                disabled={policiesViewCount.length === policiesCount}
                                            >
                                                Load more
                                            </Button>
                                    }
                                </div>
                            </div>
                        </div>
                }
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/Clients.tsx